import { CarryVestingBar } from '@/components/funds-carry/funds/CarryVestingBar';
import {
  vestedShare,
  vestingNote,
  vestingState,
} from '@/components/funds-carry/funds/carryFundValues';
import type { CarryHolding } from '../services/carryService';

export function CarryVestingProgress({ holding }: { holding: CarryHolding }) {
  return (
    <CarryVestingBar
      state={vestingState(holding)}
      share={vestedShare(holding)}
      startDate={holding.vesting_start_date}
      endDate={holding.vesting_end_date}
      note={vestingNote(holding)}
    />
  );
}
